import axios from 'axios';
import { AGENTS_ENDPOINTS } from '../config/api';
import { M_ENDPOINTS, UTIL_ENDPOINTS } from './constants';

const getS3Path = () => {
  switch (window.location.pathname.split('/')[1]) {
    case 'clients':
      return AGENTS_ENDPOINTS.S3.POST;
    case 'm':
      return M_ENDPOINTS.S3.POST;
    default:
      return UTIL_ENDPOINTS.S3.POST;
  }
};
const uploadFile = async (file, onUploadProgress, { checkAvifOnly = true } = {}) => {
  const formData = new FormData();
  formData.append("file", new Blob([file], { type: file.type }), file.name);
  formData.set("filetype", file.type);
  formData.set("check_avif_only", checkAvifOnly);

  const token = $('meta[name="csrf-token"]').attr('content');

  const config = {
    onUploadProgress: (progressEvent) => onUploadProgress(progressEvent),
    headers: {
      'X-CSRF-Token': token
    }
  };

  const url = getS3Path();
  return axios.post(url, formData, config);
};

export {
  uploadFile
};